import React from "react";
import dynamic from "next/dynamic";
// eslint-disable-next-line import/no-extraneous-dependencies
import millify from "millify";

const Chart = dynamic(() => import("react-apexcharts"), { ssr: false });

// const formatNumberToK = (number: number) => {
//   if (number >= 1000) {
//     return (number / 1000).toFixed(1) + 'k';
//   }
//   return number.toString();
// };

const DashboardProjectpie = (alldashboardDataList: any) => {
  const newCount =
    alldashboardDataList?.alldashboardDataList?.project_pie_chart?.map(
      (item: any) => item.count
    );

  const newLabel =
    alldashboardDataList?.alldashboardDataList?.project_pie_chart?.map(
      (item: any) => item._id
    );

  //console.log(newLabel, newCount, "alldashboardDataListkkkkk");

  //  // Function to customize the data labels
  const formatLabel = (value: number, index: number | any): string => {
    // if (value >= 1000) {
    //   return (value / 1000).toFixed(1) + 'k';
    // }
    //return newCount.toString();
    // return newLabel[index]; // Use the 'labels' array to display custom labels
    //console.log(index.w.globals.initialConfig.series, value,"testerr");
    //  millify(newCount, {
    //   precision: 2,
    //   locales: "en-US",
    //   space: true,
    // });
    // 3,95K
    //return value.toString()
  };

  // const formattedArray = newCount.map((value:any) =>
  //     millify(value, { precision: 2,  locales: "en-US",
  //     space: true,lowercase: true })
  //   );

  //console.log(formattedArray,"formattedArray");

  // Define the data for the chart
  const chartData = {
    options: {
      // chart: {
      //   id: 'donut-chart'
      // },
      chart: {
        width: 200,
        id: "donut-chart",
      },

      noData: {
        text: "No data found",
        align: "center",
        verticalAlign: "middle",
      },
      // labels: ["In Progress", "Completed", "Cancelled"],
      labels: newLabel,
      colors: ["#776efa", "#00cbf0", "#fe82b7"],
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              position: "bottom",
            },
          },
        },
      ],
      legend: {
        show: true,
        position: "bottom",
      },
      dataLabels: {
        //enabled: false,
        formatter: formatLabel,
      },
    },
    //series: [70, 20, 10], // Change these values according to your data
    series: newCount, // Change these values according to your data
  };

  //console.log(chartData?.series,"testt")

  return (
    <div>
      {chartData?.series?.length > 0 ? (
        <Chart
          options={chartData?.options}
          series={chartData?.series}
          type="donut"
          width="380"
        />
      ) : (
        <div>No data Found</div>
      )}
      {/* <div
        style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}
      >
        {chartData?.options?.labels?.map((label, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              alignItems: "center",
              marginRight: "20px",
            }}
          >

           
            <div
              style={{
                backgroundColor: chartData.options.colors[index],
                width: "10px",
                height: "10px",
                marginRight: "5px",
              }}
            ></div>
            <span>{label}</span>
          </div>
        ))}
      </div> */}
    </div>
  );
};

export default DashboardProjectpie;
